import * as yup from 'yup'
import { Controller, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { validationMessages } from 'constants/validation'

import { Stack, TextField } from '@mui/material'

const {
  Required
} = validationMessages

const formSchema = yup.object().shape({
	memo: yup.string().required(Required)
})

type useEditMemoFormProps = {
	memo: string
	onSubmit: (memo: string) => void
}
export const useEditMemoForm = ({
	memo,
	onSubmit
}: useEditMemoFormProps) => {
	const form = useForm({
		defaultValues: {
			memo
		},
		mode: 'onChange',
		resolver: yupResolver(formSchema)
	})
	return {
		...form,
    submit: form.handleSubmit(input => onSubmit(input.memo))
	}
}

export const EditMemoForm = ({
	control,
	formState: { errors }
}: ReturnType<typeof useEditMemoForm>) => {
	return (
		<Stack direction="row" spacing={2}>
			<Stack direction="column" flexGrow={1}>
				<Controller
					control={control}
					name="memo"
					render={({ field }) => (
						<TextField
							{...field}
							variant="outlined"
							fullWidth
							multiline
							rows={18}
							error={!!errors.memo}
							helperText={errors.memo ? errors.memo.message : ''}
						/>
					)}
				/>
			</Stack>
		</Stack>
	)
}